import type { FC } from 'react';
import React, { useCallback } from 'react';
import cn from 'classnames';
import { ChevronRightCompactSIcon } from '@alfalab/icons-glyph/ChevronRightCompactSIcon';

import type { IMenuEntry } from '../../models';

import type { TTopRow } from './models';

const filterHidden = (item: IMenuEntry) => !item.hidden;

const filterShown = (item: IMenuEntry) => !filterHidden(item);

// eslint-disable-next-line react/display-name
export const TopRow: FC<TTopRow> = React.memo(
    ({
        DataLayer,
        SegmentLink,
        handleClick,
        segmentId,
        showAll,
        styles,
        theme,
        topRow,
        withTopRowArrow = true,
    }) => {
        const renderRow = useCallback(
            (filterFn: (item: IMenuEntry) => boolean) =>
                topRow.filter(filterFn).map(({ analytics, key, link, title }: IMenuEntry) => (
                    <DataLayer key={key} data={analytics} tag={null}>
                        <SegmentLink
                            key={key}
                            link={link}
                            selected={key === segmentId}
                            title={title}
                        />
                    </DataLayer>
                )),
            [segmentId, topRow]
        );

        return (
            <div className={styles.topRowWrapper}>
                <div className={styles.shownTopRow}>{renderRow(filterHidden)}</div>
                {withTopRowArrow && (
                    <>
                        <div
                            className={cn(
                                styles.hiddenTopRow,
                                showAll && styles.hiddenTopRowAnimation
                            )}
                        >
                            {renderRow(filterShown)}
                        </div>
                        <span
                            className={cn(styles.iconRightWrapper, showAll ? styles.rotate : '')}
                            onClick={handleClick}
                        >
                            <ChevronRightCompactSIcon
                                className={cn({ [styles.iconDarkTheme]: theme === 'dark' })}
                            />
                        </span>
                    </>
                )}
            </div>
        );
    }
);
